import React, {Component} from 'react';
import posed, {PoseGroup} from 'react-pose'

import styles from './Modal.css';
import {faTimes} from "@fortawesome/pro-light-svg-icons/index";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index.es";

const AnimatedContent = posed.div({
    enter: {opacity: 1, top: 0},
    exit: {opacity: 0, top: 500}
})

const ModalWrapper = posed.div({
    enter: {opacity: 1},
    exit: {opacity: 0}
})



export default class Modal extends Component {
    state = {
        isVisible: this.props.visible
    };

    static getDerivedStateFromProps(props, state) {
        if (props.visible !== state.isVisible) {
            return {
                isVisible: props.visible
            };
        }
        return null;
    }

    render() {

        const {closeAction} = this.props;
        const {isVisible} = this.state;

        return (
            <PoseGroup>
                {
                    isVisible && [

                        <ModalWrapper className={styles.wrapper} key="modalWrapper">
                            <div onClick={() => closeAction()} className={styles.transOverlay}></div>
                            <AnimatedContent className={styles.content} key="modalContent">
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    onClick={() => closeAction()}
                                    className={styles.close}
                                    size="2x"
                                />

                                {this.props.children}

                            </AnimatedContent>
                        </ModalWrapper>

                    ]
                }

            </PoseGroup>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js